    function consoleEcrit() {
        console.log(""), console.log("%c                         Made with ♥ by Studio Dot                        ", "background: #000000; padding:5px; font-size: 10px; color: #ffffff"),
        console.log("%c                       Creative Communication Studio                      ", "background: #000000; padding:5px; font-size: 10px; color: #ffffff"),
        console.log("%c                       >>> https://studio-dot.fr <<<                      ", "background: #000000; padding:5px; font-size: 10px; color: #ffffff"),
        console.log("%c", "background: #171833; font-size: 10px; color: #f0f0f0");

        // B = !0
    }
        consoleEcrit();
